export default "__VITE_ASSET__BARyF_Yp__"